import { MyPortfolioContainer } from '@/features/my-portfolio/MyPortfolioContainer'

export function MyPortfolio() {
  return <MyPortfolioContainer />
}
